import {Component} from '@angular/core';
import {NavController, NavParams, LoadingController} from 'ionic-angular';
import {Subject} from 'rxjs/Subject';

/**
 * Generated class for the AuxTablePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-dish-table',
    templateUrl: 'dish-table.html',
})
export class DishTablePage {

    public dtOptions = {};
    dtTrigger: Subject<any> = new Subject();
    data: any;

    constructor(public navCtrl: NavController,
                public navParams: NavParams,
                public loadingCtrl: LoadingController) {

        this.data = this.navParams.get('data');

        this.dtOptions = {
            "bPaginate": 'false',
            "bLengthChange": false,
            "bFilter": true,
            "bSort": true,
            "bInfo": false,
            "bAutoWidth": true,
            "iDisplayLength": 50,
            stateSave: true,
            "bDestroy": true,
            // Declare the use of the extension in the dom parameter
            dom: 'Bfrtip',
            // Configure the buttons
            buttons: [
                'copy',
                'excel'
            ],

        };
    }



    ionViewWillEnter() {
        this.dtTrigger.next();
    }

}



// WEBPACK FOOTER //
// ./src/pages/dish/dish-table/dish-table.ts